/* para: 商品ページの RECOMMEND(sections/product-recommend.liquid)
   サーバー側で「同じ展示 → 同じタレント」を描画済み。件数が足りないときだけ、
   Shopify の関連商品(/recommendations/products?section_id=…)で末尾を埋める。
   横スクロールと ‹ › は Dawn の slider-component(global.js)に任せ、追加後に resetPages() を呼ぶ。 */
(() => {
  // 横スクロールできないとき(枚数が少ない)は ‹ 1/1 › を隠す。CHECKED ITEMS と共通
  window.paraCarouselUpdateButtons =
    window.paraCarouselUpdateButtons ||
    function (root) {
      const track = root.querySelector('.slider');
      const buttons = root.querySelector('.slider-buttons');
      if (!track || !buttons) return;
      const update = () => {
        buttons.hidden = track.scrollWidth - track.clientWidth <= 1;
      };
      update();
      if (!root.paraCarouselObserver && 'ResizeObserver' in window) {
        root.paraCarouselObserver = new ResizeObserver(update);
        root.paraCarouselObserver.observe(track);
      }
    };

  window.paraCarouselRenumber =
    window.paraCarouselRenumber ||
    function (root, sectionId) {
      root.querySelectorAll('.slider .slider__slide').forEach((li, i) => {
        li.id = `Slide-${sectionId}-${i + 1}`;
      });
      const slider = root.querySelector('slider-component');
      const total = root.querySelector('.slider-counter--total');
      if (total) total.textContent = root.querySelectorAll('.slider .slider__slide').length;
      if (slider && typeof slider.resetPages === 'function') slider.resetPages();
      window.paraCarouselUpdateButtons(root);
    };

  if (customElements.get('para-product-recommend')) return;

  customElements.define(
    'para-product-recommend',
    class ParaProductRecommend extends HTMLElement {
      connectedCallback() {
        this.wrapper = this.closest('.para-carousel-wrapper');
        this.track = this.querySelector('.slider');
        this.limit = parseInt(this.dataset.limit, 10) || 8;
        const count = this.track ? this.track.children.length : 0;

        customElements.whenDefined('slider-component').then(() => window.paraCarouselUpdateButtons(this));

        this.needsFill = !(count >= this.limit || this.dataset.fill !== 'true' || !this.dataset.productId);
        if (!this.needsFill) {
          if (count === 0 && this.wrapper) this.wrapper.hidden = true;
          return;
        }

        // 画面の近くに来てから関連商品を取りに行く(Dawn の product-recommendations と同じ考え方)
        if (!('IntersectionObserver' in window)) return this.fill();
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((e) => e.isIntersecting)) return;
            this.observer.disconnect();
            this.fill();
          },
          { rootMargin: '0px 0px 600px 0px' }
        );
        // 0件で wrapper が hidden(display:none)のときは交差判定されないので、外側のセクション要素を見る
        const target = this.wrapper && this.wrapper.hidden ? this.wrapper.parentElement || this : this.wrapper || this;
        this.observer.observe(target);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      // para V1.10: タブで RECOMMEND が隠れている間は交差判定が来ないので、タブ側(para-herlipto.js)から呼ぶ。1 回だけ
      requestFill() {
        if (!this.needsFill || this.fillStarted) return;
        if (this.observer) this.observer.disconnect();
        this.fill();
      }

      async fill() {
        if (this.fillStarted) return;
        this.fillStarted = true;
        try {
          const url = `${this.dataset.url}?product_id=${encodeURIComponent(this.dataset.productId)}&limit=10&intent=related&section_id=${encodeURIComponent(this.dataset.sectionId)}`;
          const response = await fetch(url);
          if (!response.ok) throw new Error(`HTTP ${response.status}`);
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const seen = new Set(
            Array.from(this.track.querySelectorAll('[data-product-id]')).map((el) => el.dataset.productId)
          );
          seen.add(String(this.dataset.productId));
          // para V1.21: 売り切れの商品の下部「今買える作品」の段に出ている作品は、関連商品でも重ねて足さない
          document.querySelectorAll('.para-soldout-more [data-product-id]').forEach((el) => seen.add(el.dataset.productId));
          let count = this.track.children.length;
          html.querySelectorAll('.slider__slide[data-product-id]').forEach((li) => {
            if (count >= this.limit || seen.has(li.dataset.productId)) return;
            seen.add(li.dataset.productId);
            this.track.appendChild(document.importNode(li, true));
            count += 1;
          });
        } catch (error) {
          console.warn('[RECOMMEND] 関連商品の取得に失敗しました', error);
        }
        const total = this.track.children.length;
        if (this.wrapper) this.wrapper.hidden = total === 0;
        if (total > 0) {
          await customElements.whenDefined('slider-component');
          window.paraCarouselRenumber(this, this.dataset.sectionId);
        }
      }
    }
  );
})();
